module.exports = __webpack_public_path__ + "static/img/Opportunities_EnjoyingLA_Shopping.c6703fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Opportunities_EnjoyingLA_Shopping.jpg
// module id = fDuq
// module chunks = 1